module.exports = __webpack_public_path__ + "img/case7.b2f745a9.png";